export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';

export const CLEAR_TRANSLATIONS = 'CLEAR_TRANSLATIONS';